(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('TransferBalanceDialogController', TransferBalanceDialogController);

    TransferBalanceDialogController.$inject = ['$scope', '$stateParams', '$uibModalInstance', 'entity', 'Billing',  'LigneContrat'];

    function TransferBalanceDialogController ($scope, $stateParams, $uibModalInstance, entity, Billing,  LigneContrat) {
        var vm = this;
        vm.balanceTransfer  = entity;
        vm.lignecontrats = LigneContrat.findActifByContrat({idContrat:$stateParams.id});
        vm.getBalanceAfterTransfer = getBalanceAfterTransfer;
        vm.getCurrentBalance = getCurrentBalance;
        vm.hasTransferPreview = hasTransferPreview;

        vm.lignecontrats.$promise.then(function(result) {
            vm.lignecontrats = result;

            if (vm.balanceTransfer.ligneContrat && vm.balanceTransfer.ligneContrat.id) {
                vm.balanceTransfer.ligneContrat = findLineById(vm.balanceTransfer.ligneContrat.id);
            }

            if (vm.balanceTransfer.ligneContratCible && vm.balanceTransfer.ligneContratCible.id) {
                vm.balanceTransfer.ligneContratCible = findLineById(vm.balanceTransfer.ligneContratCible.id);
            }
        });
                 
        var onSaveSuccess = function (result) {
            $scope.$emit('wamasysApp:impactPenalitRemiseRegulUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            Billing.saveBalanceTransfer(vm.balanceTransfer , onSaveSuccess, onSaveError);
            
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

        function findLineById(id) {
            var matchedLine = null;

            angular.forEach(vm.lignecontrats, function(ligneContrat) {
                if (!matchedLine && String(ligneContrat.id) === String(id)) {
                    matchedLine = ligneContrat;
                }
            });

            return matchedLine;
        }

        function getCurrentBalance(ligneContrat) {
            if (!ligneContrat) {
                return 0;
            }
            if (ligneContrat.moneyboxApresPaiement !== undefined && ligneContrat.moneyboxApresPaiement !== null) {
                return ligneContrat.moneyboxApresPaiement;
            }
            if (ligneContrat.derniereLignePaiement
                && ligneContrat.derniereLignePaiement.moneyboxApresPaiement !== undefined
                && ligneContrat.derniereLignePaiement.moneyboxApresPaiement !== null) {
                return ligneContrat.derniereLignePaiement.moneyboxApresPaiement;
            }
            return 0;
        }

        function getBalanceAfterTransfer(ligneContrat, direction) {
            var amount = Number(vm.balanceTransfer.amount || 0);
            var currentBalance = getCurrentBalance(ligneContrat);

            if (!ligneContrat || !amount) {
                return currentBalance;
            }

            if (direction === 'DEBIT') {
                return currentBalance - amount;
            }

            return currentBalance + amount;
        }

        function hasTransferPreview() {
            return vm.balanceTransfer.ligneContrat
                && vm.balanceTransfer.ligneContratCible
                && vm.balanceTransfer.amount > 0;
        }
    }
})();
